var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['atom-button', `atom-button--${_vm.variant}`, `atom-button--${_vm.size}`, { 'atom-button--disabled': _vm.disabled }],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }